module.exports = __webpack_public_path__ + "img/9.3ac12100.png";